import { mount } from 'svelte'

import './styles/fontes.css'
import './styles/tokens.css'
import './styles/base.css'

import App from './App.svelte'
import { chargerMoteur } from './rules'

// Le moteur est chargé avant le premier rendu : un écran de Création qui
// s'afficherait sans référentiel ne saurait ni les Régions, ni les plafonds,
// et devrait tout redessiner une fois les données arrivées.
const erreur = await chargerMoteur()

const app = mount(App, {
  target: document.getElementById('app')!,
  props: { erreur },
})

export default app
